import { ColDef } from 'ag-grid-community';
import { IntlShape } from 'react-intl';
import { RIGHT_ALIGNED } from 'common/constants';
import { labelMessages } from 'pages/VendorPaymentResultPage/messages';

export const failedPrintChecksColumns = (intl: IntlShape): ColDef[] => [
  {
    field: 'vendorNo',
    headerName: intl.formatMessage(labelMessages.vendorNoLabel),
    resizable: true
  },
  {
    field: 'vendorName',
    headerName: intl.formatMessage(labelMessages.vendorNameLabel),
    sortable: true,
    resizable: true
  },
  {
    field: 'checkAmount',
    headerName: intl.formatMessage(labelMessages.amountLabel),
    minWidth: 80,
    sortable: true,
    resizable: true,
    type: RIGHT_ALIGNED
  }
];
